import React from 'react';
import { Link } from 'react-router-dom';

const PageNotFound = () => {
    return (
        <div>
            <div className="main-content">
                <div className="page-content">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
                        <div className="text-center">
                            <h1 className="display-1 fw-bold text-danger">404</h1>
                            <h2 className="mb-4">Page Not Found</h2>
                            <p className="mb-4 text-muted">
                                The page you are looking for might have been removed, had its name changed,
                                or is temporarily unavailable.
                            </p>
                            <Link to="/" className="btn btn-primary">
                                Go to Homepage
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageNotFound;
